import React from 'react';
import PartnerOfferingList from './PartnerOfferingList';

const PartnerServiceList = () => {
  return <PartnerOfferingList offeringKind="Service" pageTitle="Partner Services" />;
};

export default PartnerServiceList;
